__turbopack_context__.v({
  "disabled": "toggle-module__OYNwgW__disabled",
  "ideeri": "toggle-module__OYNwgW__ideeri",
  "ideeri-secondary": "toggle-module__OYNwgW__ideeri-secondary",
  "input": "toggle-module__OYNwgW__input",
  "label": "toggle-module__OYNwgW__label",
  "secondary": "toggle-module__OYNwgW__secondary",
});
